import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { Type, Brand } from "@models/interfaces";
import { BrandService } from "@shared/services/brand.service";
import { TypeService } from "@shared/services/type.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: "mv-lists-home",
    styleUrls: ["./home.component.scss"],
    templateUrl: "./home.component.html",
})
export class HomeComponent implements OnInit, AfterViewInit {
    public brand: Brand;
    public type: Type;
    @Input() isOpenPopup: boolean = false;
    @ViewChild("imgBackground") imgBackground: ElementRef<HTMLDivElement>;

    private readonly destroy$: Subject<boolean> = new Subject<boolean>();

    public year: number = new Date().getFullYear();

    constructor(
        private brandService: BrandService,
        private typeService: TypeService,
    ) {}

    ngOnInit() {
        this.brandService.brand$.pipe(takeUntil(this.destroy$)).subscribe((brandVal) => {
            this.brand = brandVal;
        });

        this.typeService.type$.pipe(takeUntil(this.destroy$)).subscribe((typeVal) => {
            this.type = typeVal;
        });
    }
    ngAfterViewInit() {
        this.imgBackground.nativeElement.style.backgroundImage = `url('/assets/img/${this.brand}/${this.type}/default-cover.jpg')`;
    }
    public showPopup(): void {
        this.isOpenPopup = !this.isOpenPopup;
    }
}
